import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import FundsCalculatorModal from "../funds-calculator/funds-calculator-modal";

export default function WishlistCard({
  course,
  onRemove,
  // onEnroll,
  setOpenCalc,
  setSelectedCourse,
  selectedCourse,
  openCalc,
}) {
  const navigate = useNavigate();

  return (
    <div className="w-full rounded-xl border border-[#F9FAFB] bg-white shadow-[0px_2px_6px_rgba(0,0,0,0.2)]">
      <div className="p-4">
        {/* Header */}
        <div className="overflow-hidden rounded-xl border border-[#E3D8F5]">
          <div className="flex items-center justify-between bg-[#FBF5FF] px-4 py-3">
            <h3 className="text-md font-semibold text-[#1E1E1E] leading-tight">
              {course.course_name}
            </h3>

            <button
              onClick={() => onRemove(course.id)}
              className="rounded-full border border-[#E3D8F5] bg-white p-1.5 hover:bg-[#F4ECFF]"
            >
              <Heart className="h-5 w-5 fill-[#9C27B0] text-[#9C27B0]" />
            </button>
          </div>

          {/* Intake */}
          <div className="bg-gradient-to-r from-white to-[#F0DEFD] px-4 py-2">
            <p className="text-[14px] font-semibold text-[#572575]">
              Intake:{" "}
              {new Date(0, course.intake_month_from - 1).toLocaleString(
                "en-US",
                {
                  month: "short",
                }
              )}{" "}
              {course.intake_year_from}
            </p>
          </div>
        </div>

        {/* University */}
        <div className="my-4 rounded-2xl bg-white p-4 shadow-[0px_2px_10px_rgba(0,0,0,0.1)]">
          <div className="flex items-center gap-1 text-md text-[#313439]">
            <img src="/university.svg" className="h-5 w-auto" />
            {course.university_name}
          </div>

          <div className="mt-2 flex items-center gap-2 text-md text-[#313439]">
            <img src="/location.svg" className="h-5 w-auto" />
            {course.country_name}
          </div>
        </div>

        {/* Fees */}
        <div className="mb-4 rounded-2xl bg-white p-4 shadow-[0px_2px_10px_rgba(0,0,0,0.1)]">
          <div className="mb-3 flex items-center gap-2 font-bold text-[#313439]">
            <img src="/money.png" className="h-5 w-5" />
            Fees
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-bold text-[#3F424C]">
                {course.currency_code} {course.application_fee || 0}
              </p>
              <p className="text-sm text-[#5F6570]">Application Fees</p>
            </div>

            <div>
              <p className="text-sm font-bold text-[#3F424C]">
                {course.currency_code} {course.total_tution_fees || 0}
              </p>
              <p className="text-sm text-[#5F6570]">Tuition Fees</p>
            </div>
          </div>
        </div>

        {/* Test Eligibility */}
        <div className="mb-4 rounded-2xl bg-white p-4 shadow-[0px_2px_10px_rgba(0,0,0,0.1)]">
          <div className="mb-3 flex items-center gap-2 font-bold text-[#313439]">
            <img src="/notes.png" className="h-5 w-auto" />
            Test eligibility
          </div>

          <div className="grid grid-cols-4 gap-2">
            {course.englishTests?.slice(0, 4).map((test, idx) => (
              <div key={idx}>
                <p className="text-[12px] font-bold text-[#3F424C]">
                  {test.overall}
                </p>
                <p className="text-[12px] text-[#5F6570]">{test.test_type}</p>
              </div>
            ))}
          </div>
        </div>

        <FundsCalculatorModal
          isOpen={openCalc}
          onClose={() => setOpenCalc(false)}
          course={selectedCourse}
        />

        {/* Buttons */}
        <div className="flex gap-4">
          <button
            onClick={() => {
              setOpenCalc(true);
              setSelectedCourse(course);
            }}
            className="h-[44px] w-full rounded-[14px] border border-[#7E838D] text-[15px] font-semibold text-[#3F424C]"
          >
            Calculate Funds
          </button>

          <button
            // onClick={() => onEnroll(course)}
            className="h-[44px] w-full rounded-[14px] bg-[#5B1E77] text-[15px] font-semibold text-white shadow-[0px_4px_10px_rgba(91,30,119,0.25)]"
          >
            Enroll Now
          </button>
        </div>
      </div>
    </div>
  );
}
